import { api } from './api';
import { PaginatedList, PaginatedRequest } from '../types';
import { FranchiseType } from './franchise';
import { UserType } from './users';

export const getMessagesList = (params: PaginatedRequest) =>
  api.request<MessagesList>({
    method: 'GET',
    url: '/messages/',
    params,
  });

export const createMessage = (data: MessagesType) =>
  api.request<MessagesType>({
    method: 'POST',
    url: '/messages/',
    data,
  });

/**
 * Edit a message already sent: body and display window only.
 * The audience is immutable (enforced by MessageEditSerializer too).
 */
export const updateMessage = (
  id: number,
  data: {
    text: string;
    dateFrom?: string | null;
    dateTo?: string | null;
  },
) =>
  api.request<MessagesType>({
    method: 'PATCH',
    url: `/messages/${id}/`,
    data,
  });

/** Permanently removes a message. There is no soft-delete on Message. */
export const deleteMessage = (id: number) =>
  api.request<void>({
    method: 'DELETE',
    url: `/messages/${id}/`,
  });

/**
 * Branches a Branch Admin may address in Settings > Messages.
 *
 * Not `getFranchiseList` on purpose: /api/v1/franchises/ is scoped to the
 * branches the caller belongs to, and widening it would change every other
 * franchise picker in the app (users, fees, jurisdictions, trades...).
 */
export const getMessageBranches = () =>
  api.request<MessageBranchType[]>({
    method: 'GET',
    url: '/messages/branches/',
  });

export interface MessageBranchType {
  id: number;
  name: string;
}

export const reUseMessage = ({ id }: { id: number }) =>
  api.request<MessagesType>({
    method: 'POST',
    url: `/messages/${id}/resend/`,
  });

type MessagesList = PaginatedList<MessagesType>;

export interface MessagesType {
  text: string;
  franchise: number[] | string | FranchiseType[];
  userRole: number;
  addresses: number[] | UserType[];
  publicationDate: string;
  addressesList: string;
  /** Optional display window (ISO yyyy-MM-dd). Null = show on send day only. */
  dateFrom?: string | null;
  dateTo?: string | null;
}

export interface MessagesTableType {
  id: number;
  text: string;
  userRole: number;
  publicationDate: string;
  franchiseNames: number[];
  addressesList: string;
  isActive: boolean;
  isDeleted: boolean;
  dateFrom?: string | null;
  dateTo?: string | null;
}

export interface MessagesButtonType {
  id: number;
  title: string;
}

export type MessagesButtonTypeLink = MessagesButtonType & {
  linkTo: string;
};
